import React, { useEffect, useState } from "react";
import {
  Container,
  Card,
  Typography,
  TextField,
  MenuItem,
  Button,
  Grid,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  InputLabel,
  FormControl,Checkbox,FormGroup,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import BASE_URL from "../config";
const EditStudentPage = () => {
  const { studentID } = useParams();
  const navigate = useNavigate();
  const [student, setStudent] = useState({
    StudentName: "",
    MobileNumber: "",
    AcademicYearID: "",
    CourseID: "",
    ClassID: "",
    SectionID:"",
    Address: "",
    ParentName: "",
    ParentContact: "",
  });
  const [courses, setCourses] = useState([]);
  const [academicYears, setAcademicYears] = useState([]);
  const [classes, setClasses] = useState([]);
  const [section, setSection] = useState([]);
  const [selectedSection, setSelectedSection] = useState("");
  const [feeCategories, setFeeCategories] = useState([]);
  const [selectedFeeCategory, setSelectedFeeCategory] = useState([]);
  const [routeOptions, setRouteOptions] = useState([]);
  const [selectedRoute, setSelectedRoute] = useState("");
  const [initialAssignedCategories, setInitialAssignedCategories] = useState([]);
  const [routeFees, setRouteFees] = useState({});       // categoryID -> selected fee
  const adminName = sessionStorage.getItem("adminName");
const [assignedCategoryFees, setAssignedCategoryFees] = useState({}); // from backend when editing
const [selectedRoutes, setSelectedRoutes] = useState({});
  useEffect(() => {
    fetchStudentDetails();
    fetchFeeCategories();
    fetchCourses();
  }, []);
useEffect(() => {
  if (student.CourseID) {
    fetchFeeCategories();
  }
}, [student.CourseID]);
  const fetchStudentDetails = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/getStudentDetails/${studentID}`);
      //setStudent(res.data);
      setStudent({
        StudentName: res.data.StudentName || "",
        MobileNumber: res.data.MobileNumber || "",
        AcademicYearID: res.data.AcademicYearID || "",
        CourseID: res.data.CourseID || "",
        ClassID: res.data.ClassID || "",
        SectionID:res.data.SectionID || "",
        Address: res.data.Address || "",
        ParentName: res.data.ParentName || "",
        ParentContact: res.data.ParentContact || "",
      });
      if (res.data.CourseID) fetchAcademicYears(res.data.CourseID);
      if (res.data.CourseID) fetchClasses(res.data.CourseID);
      if (res.data.ClassID) {
  await fetchSection(res.data.ClassID);
  if (res.data.SectionID) setSelectedSection(res.data.SectionID);
}
    const assigned = {};
    if (res.data.CategoryFees && Array.isArray(res.data.CategoryFees)) {
      res.data.CategoryFees.forEach(item => {
        assigned[item.CategoryID] = item.Fees;
         assigned[item.CategoryID] = item.RouteID;
        
      });
      setRouteFees(assigned);
      setSelectedRoutes(assigned);
    }
    //setAssignedCategoryFees(assigned);
    for (const categoryID of Object.keys(assigned)) {
  try {
    const res = await axios.get(`${BASE_URL}/api/getRouteDetails/${categoryID}`);
    setRouteOptions(prev => ({
      ...prev,
      [categoryID]: res.data
       
    }
        
  ));
 console.log("Routes of selected category:",[categoryID]);
  } catch (err) {
    console.error(`Failed to fetch route details for category ${categoryID}:`, err);
  }
}
    setRouteFees(assigned); // Prefill routeFees select with existing ones
    const selectedIDs = Object.keys(assigned).map(id => parseInt(id));
    setSelectedFeeCategory(selectedIDs);
    setInitialAssignedCategories(selectedIDs); // Store separately for comparison
    } catch (error) {
      console.error("Error fetching student details:", error);
    }
  };
  const fetchCourses = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/coursesa`);
      setCourses(res.data);
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };
  const fetchAcademicYears = async (courseID) => {
    try {
      const res = await axios.get(`${BASE_URL}/api/academicYears/${courseID}`);
      setAcademicYears(res.data);
    } catch (error) {
      console.error("Error fetching academic years:", error);
    }
  };
  const fetchClasses = async (courseID) => {
    try {
      const res = await axios.get(`${BASE_URL}/api/classes`, {
  params: { course: courseID }
});
      setClasses(res.data);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };
   const fetchSection = async (classID) => {
    try {
      //console.log(academicYearID);
      const res = await axios.get(`${BASE_URL}/api/sections/${classID}`);
      setSection(res.data);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };
  const handleCourseChange = (event) => {
    const courseID = event.target.value;
    setStudent({
      ...student,
      CourseID: courseID,
      AcademicYearID: "",
      ClassID: "",
    });
    fetchAcademicYears(courseID);
    fetchClasses(courseID);
    setSection([]);
setSelectedSection("");
  };

  const handleAcademicYearChange = (event) => {
    const academicYearID = event.target.value;
    setStudent({ ...student, AcademicYearID: academicYearID, ClassID: "" });
    setSection([]);
setSelectedSection("");
    //fetchClasses(academicYearID);
  };
  const fetchFeeCategories = async () => {
    if (!student?.CourseID) return; // ✅ prevent empty call
    try {
       const res = await axios.get(`${BASE_URL}/api/getNonRegularFeeCategoriess`, {
            params: { courseID: student.CourseID },
          });
          console.log(student.CourseID); 
      setFeeCategories(res.data);
    } catch (error) {
      console.error("Error fetching fee categories:", error);
    }
  };

 /*  const fetchRouteDetails = async (categoryID) => {
    try {
      const res = await axios.get(`${BASE_URL}/getRouteDetails/${categoryID}`);
      setRouteOptions(res.data);
    } catch (error) {
      console.error("Error fetching route details:", error);
    }
  }; */
//21-7-25
const fetchRouteDetails = async (categoryID) => {
  try {
    const res = await axios.get(`${BASE_URL}/api/getRoutesByCategory/${categoryID}`);
    setRouteOptions((prev) => ({
      ...prev,
      [categoryID]: res.data
    }));
  } catch (err) {
    console.error("Failed to fetch route details:", err);
  }
};
  /*  const handleFeeCategoryChange = (event) => {
    setSelectedFeeCategory(event.target.value);
    setSelectedRoute(""); 
    if (event.target.value) fetchRouteDetails(event.target.value);
  }; */
 /*  const handleFeeCategoryChange = (event) => {
    const categoryID = event.target.value;
    setSelectedFeeCategory(categoryID);
    setSelectedRoute("");

    if (categoryID) {
      fetchRouteDetails(categoryID);
    }
  }; */
 /* const handleFeeCategoryChange = async (event, categoryID) => {
  let updatedSelected = [...selectedFeeCategory];
  if (event.target.checked) {
    // Checkbox selected → add to local state
    updatedSelected.push(categoryID);
    await fetchRouteDetails(categoryID); // optional preload
      setSelectedFeeCategory(updatedSelected);
  } else {
    // Only show confirm if category was already assigned before
    const isPreviouslyAssigned = initialAssignedCategories.includes(categoryID);

    if (isPreviouslyAssigned) {
      const confirmed = window.confirm("Are you sure you want to delete this previously assigned fee category?");
      if (!confirmed) return;

      try {
        await axios.delete(`${BASE_URL}/removeCategoryFee`, {
          data: {
            studentId: studentID,
            categoryId: categoryID,
          },
        });
        updatedSelected = updatedSelected.filter((id) => id !== categoryID);
         setSelectedFeeCategory(updatedSelected);
        const updatedFees = { ...routeFees };
        delete updatedFees[categoryID];
        setRouteFees(updatedFees);
      } catch (error) {
        console.error("Error deleting category fee:", error);
        alert("Failed to delete assigned fee category.");
        return;
      }
    } else {
      // Just unselect from local state without API call
      updatedSelected = updatedSelected.filter((id) => id !== categoryID);
      setSelectedFeeCategory(updatedSelected);
      const updatedFees = { ...routeFees };
      delete updatedFees[categoryID];
      setRouteFees(updatedFees);
    }
  }

  //setSelectedFeeCategory(updatedSelected);
}; */
const handleFeeCategoryChange = async (event, categoryID) => {
  let updatedSelected = [...selectedFeeCategory];

  if (event.target.checked) {
    if (!updatedSelected.includes(categoryID)) {
      updatedSelected.push(categoryID);
    }

    // 🧠 Fetch route options BEFORE updating state
    try {
      const res = await axios.get(`${BASE_URL}/api/getRouteDetails/${categoryID}`);
      setRouteOptions((prev) => ({
        ...prev,
        [categoryID]: res.data
      }));
    } catch (err) {
      console.error("Failed to fetch route details:", err);
    }

    setSelectedFeeCategory(updatedSelected);
  } else {
    const isPreviouslyAssigned = initialAssignedCategories.includes(categoryID);
    if (isPreviouslyAssigned) {
      const confirmed = window.confirm("This category is already assigned. Confirm delete?");
      if (!confirmed) return;

      try {
        await axios.delete(`${BASE_URL}/api/removeCategoryFee`, {
          data: {
            studentId: studentID,
            categoryId: categoryID,
          },
        });

        updatedSelected = updatedSelected.filter((id) => id !== categoryID);
        setSelectedFeeCategory(updatedSelected);
        const updatedFees = { ...routeFees };
        delete updatedFees[categoryID];
        setRouteFees(updatedFees);
      } catch (error) {
        console.error("Error deleting category fee:", error);
        alert("Failed to delete assigned fee category.");
      }
    } else {
      updatedSelected = updatedSelected.filter((id) => id !== categoryID);
      setSelectedFeeCategory(updatedSelected);
      const updatedFees = { ...routeFees };
      delete updatedFees[categoryID];
      setRouteFees(updatedFees);
    }
  }
};

  const handleUpdate = async () => {
    try {
      // 1. Get the old student data BEFORE updating
    const oldStudentRes = await axios.get(`${BASE_URL}/api/getStudentDetails/${studentID}`);
    const oldStudent = oldStudentRes.data;

    // 2. Check if class has changed
    const isClassChanged = oldStudent.ClassID !== student.ClassID;
    console.log("Class changed:", isClassChanged);

    // 3. Update student details
    await axios.put(`${BASE_URL}/api/updateStudent/${studentID}`, {
      ...student,
    });
    // 4. If class changed, update TotalFee with new class fee
    if (isClassChanged) {
       // 4.1 Get new class fee
      const classFeeRes = await axios.get(`${BASE_URL}/api/getClassFee/${student.ClassID}`);
      const newClassFee = classFeeRes.data.Fee;
      console.log(newClassFee);
     // 4.2 Update TotalFee with new class fee
      await axios.put(`${BASE_URL}/api/updateTotalFeeClassChange`, {
        StudentID: studentID,
        ClassID: student.ClassID,
        CourseID: student.CourseID,
        AcademicYearID: student.AcademicYearID,
        NewFee: newClassFee,
        UpdatedBy: adminName,
        UpdatedDate: new Date().toISOString().split("T")[0],
      });
       // 4.3 Get category fee for new class
  const categoryFeeRes = await axios.get(`${BASE_URL}/api/getCategoryFeeByClass/${student.ClassID}`);
  const { CategoryID, CFee } = categoryFeeRes.data;

 // 4.4 Insert category fee for class change
  /* await axios.post(`${BASE_URL}/api/insertCategoryFee`, {
    StudentID: studentID,
    CategoryID: CategoryID,
    Fees: CFee,
    AcademicYearID: student.AcademicYearID,
    CourseID: student.CourseID,
    ClassID: student.ClassID,
    UpdatedBy: adminName,
    UpdatedDate: new Date().toISOString().split("T")[0],
     skipTotalFeeUpdate: true   // 👈 Pass this flag to skip updating TotalFee
  }); */

  await axios.put(
          `${BASE_URL}/api/updateCategoryFeeClassChange`,
          {
            StudentID: studentID,
            CategoryID,
            Fees: CFee,
            AcademicYearID: student.AcademicYearID,
            CourseID: student.CourseID,
            ClassID: student.ClassID,
            UpdatedBy: adminName
          }
        );
  
    }
      // 5. Insert selected category fee (if any)
    /*   if (selectedFeeCategory && selectedRoute) {
        //await axios.post(`${BASE_URL}/insertCategoryFee`, {
        const catFeeRes = await axios.post(`${BASE_URL}/insertCategoryFee`, {
          StudentID: studentID,
          CategoryID: selectedFeeCategory,
          Fees: selectedRoute?.Fee || 0,
          AcademicYearID: student.AcademicYearID,
          CourseID: student.CourseID,
          ClassID: student.ClassID,
          UpdatedBy: adminName,
          UpdatedDate: new Date().toISOString().split("T")[0],
        });
        if (!catFeeRes.data.skipMessage) {
  alert(catFeeRes.data.message);
}
      } */
     if (selectedFeeCategory.length > 0) {
      // Validate route fees
  for (let catID of selectedFeeCategory) {
    const fee = routeFees[catID];
    if (fee === undefined || fee === null || isNaN(fee) || fee <= 0) {
      // Find the category name for the given ID
      const category = feeCategories.find((c) => c.CategoryID === catID);
      const categoryName = category ? category.CategoryName : `Category ID ${catID}`;
      alert(`Please select a valid Route Fee for ${categoryName}`);
      return;
    }
  }
  const feePayload = selectedFeeCategory.map((catID) => ({
    CategoryID: catID,
    Fees: routeFees[catID] || 0, // routeFees should be a state like { 1: 2000, 2: 3000 }
  }));
  const catFeeRes = await axios.post(`${BASE_URL}/api/insertMultipleCategoryFees`, {
    StudentID: studentID,
    AcademicYearID: student.AcademicYearID,
    CourseID: student.CourseID,
    ClassID: student.ClassID,
    UpdatedBy: adminName,
    UpdatedDate: new Date().toISOString().split("T")[0],
    CategoryFees: feePayload, // array of { CategoryID, Fees }
  });

  if (catFeeRes.data.message) {
    alert(catFeeRes.data.message);
  }
}
      alert("Student details updated successfully!");
      navigate("/students");
    } catch (error) {
      console.error("Error updating student details:", error);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Card sx={{ p: 4, boxShadow: 3 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Edit Student Details
        </Typography>
        <Grid container spacing={2}>
        {/*   <Grid container spacing={2}> */}
        <Grid item xs={12}>
          <FormControl fullWidth>
            <InputLabel>Course</InputLabel>
            <Select value={student.CourseID} onChange={handleCourseChange}>
              {courses.map((course) => (
                <MenuItem key={course.CourseID} value={course.CourseID}>
                  {course.CourseName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <FormControl fullWidth>
            <InputLabel>Academic Year</InputLabel>
            <Select
              value={student.AcademicYearID}
              onChange={handleAcademicYearChange}
              disabled={!student.CourseID}
            >
              {academicYears.map((year) => (
                <MenuItem key={year.AcademicYearID} value={year.AcademicYearID}>
                  {year.AcademicYearName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <FormControl fullWidth>
            <InputLabel>Class</InputLabel>
            <Select
              value={student.ClassID}
              onChange={(e) => {
                setStudent({ ...student, ClassID: e.target.value, SectionID: "" })
                fetchSection(e.target.value);  // Load sections dynamically
    //setSelectedSection(""); // Reset section selection
              }}
              disabled={!student.CourseID}
            >
              {classes.map((cls) => (
                <MenuItem key={cls.id} value={cls.id}>
                  {cls.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        {/*Section Part */}
        {section.length > 0 && (
  <Grid item xs={12}>
   {/*  <FormControl fullWidth>
      <InputLabel>Section</InputLabel>
      <Select
        value={selectedSection}
        onChange={(e) => setSelectedSection(e.target.value)}
      >
        {section.map((sec) => (
          <MenuItem key={sec.SectionID} value={sec.SectionID}>
            {sec.SectionName}
          </MenuItem>
        ))}
      </Select>
    </FormControl> */}
    <FormControl fullWidth>
  <InputLabel>Section</InputLabel>
  <Select
    value={student.SectionID}
    onChange={(e) =>
      setStudent({ ...student, SectionID: e.target.value })
    }
  >
    {section.map((sec) => (
      <MenuItem key={sec.SectionID} value={sec.SectionID}>
        {sec.SectionName}
      </MenuItem>
    ))}
  </Select>
</FormControl>
  </Grid>
)}

        {/* <Grid container spacing={2}> */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Student Name"
              value={student.StudentName}
              onChange={(e) =>
                setStudent({ ...student, StudentName: e.target.value })
              }
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Mobile Number"
              value={student.MobileNumber}
              onChange={(e) =>
                setStudent({ ...student, MobileNumber: e.target.value })
              }
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Address"
              value={student.Address || ""}
              onChange={(e) =>
                setStudent({ ...student, Address: e.target.value })
              }
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Parent Name"
              value={student.ParentName || ""}
              onChange={(e) =>
                setStudent({ ...student, ParentName: e.target.value })
              }
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Parent Contact"
              value={student.ParentContact || ""}
              onChange={(e) =>
                setStudent({ ...student, ParentContact: e.target.value })
              }
            />
          </Grid>

          {/* Non-Regular Fee Categories */}
          <Grid item xs={12}>
            <Typography variant="h6">Non-Regular Fees</Typography>
           {/*  <RadioGroup
              row
              value={selectedFeeCategory}
              onChange={handleFeeCategoryChange}
            >
              {feeCategories.map((fee) => (
                <FormControlLabel
                  key={fee.CategoryID}
                  value={fee.CategoryID}
                  control={<Radio />}
                  label={fee.CategoryName}
                />
              ))}
            </RadioGroup> */}
            <FormGroup row>
  {feeCategories.map((fee) => (
    <FormControlLabel
      key={fee.CategoryID}
      control={
        <Checkbox
          checked={selectedFeeCategory.includes(fee.CategoryID)}
          onChange={(e) => handleFeeCategoryChange(e, fee.CategoryID)}
        />
      }
      /* label={fee.CategoryName}
    />
  ))} */
 label={
        <>
          {fee.CategoryName}
          {routeFees[fee.CategoryID] !== undefined && (
            <span style={{ marginLeft: "8px", color: "#4caf50", fontWeight: 500 }}>
              ₹{routeFees[fee.CategoryID]}
            </span>
          )}
        </>
      }
    />
  ))}
</FormGroup>
          </Grid>

          {/* Route Selection */}
        {selectedFeeCategory.map((categoryID) => (
          /*   routeOptions[categoryID] && ( */
  <Grid item xs={12} key={categoryID}>
    {/* <Typography>Route Fee for Category ID {categoryID}</Typography> */}
     <Typography>Route Fees for {feeCategories.find(f => f.CategoryID === categoryID)?.CategoryName}</Typography>
    <FormControl fullWidth>
      <InputLabel>Select Route Fees</InputLabel>
      {/* <Select
        value={routeFees[categoryID] || ""}
        onChange={(e) =>
          setRouteFees((prev) => ({
            ...prev,
            [categoryID]: e.target.value
          }))
        }
      > */}

      <Select
  value={selectedRoutes[categoryID] || ""}
  onChange={(e) => {
    const routeId = e.target.value;

    const selectedRoute =
      routeOptions[categoryID]?.find(
        (r) => r.RouteID === routeId
      );

    setSelectedRoutes((prev) => ({
      ...prev,
      [categoryID]: routeId,
    }));

    setRouteFees((prev) => ({
      ...prev,
      [categoryID]: selectedRoute?.Fee || 0,
    }));
  }}
>
        {(routeOptions[categoryID] || []).map((route) => (
          <MenuItem key={route.RouteID} 
         /*  value={route.Fee} */
             value={route.RouteID}
          >
            {route.RouteName} (₹{route.Fee})
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>
          /*   ) */
))}

          <Grid item xs={12}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={handleUpdate}
            >
              Update Student
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
};

export default EditStudentPage;
